import React from 'react'
import UserProfileService from './../../../../shared/services/UserProfile.service'
import AdminContentEditPopupComponent from './../../../../components/adminShared/AdminContentEditPopupComponent'
import { MDBRow, MDBCol } from 'mdb-react-ui-kit'

const EditDowngradeContentButtons = () => {
  if (!UserProfileService.isA(['system-admin', 'internal-admin', 'internal-staff', 'agency-owner'], true)) return <></>

  return (
    <MDBRow>
      <MDBCol size='12' md='6'>
        <AdminContentEditPopupComponent
          type='RTE'
          iconPosition='top-left'
          pageId={67}
          color='white'
          btnLabel='Edit Affiliate Downgrade Content'
          btnClass='btn-block'
        />
      </MDBCol>
      <MDBCol size='12' md='6'>
        <AdminContentEditPopupComponent
          type='RTE'
          iconPosition='top-left'
          pageId={66}
          color='white'
          btnLabel='Edit Associate Downgrade Content'
          btnClass='btn-block'
        />
      </MDBCol>
    </MDBRow>
  )
}

export default EditDowngradeContentButtons
